import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ItemTrackings, uploadItemTrackingApi } from "@tKgpco/Services/ItemTrackingService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = any & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, ItemTrackings>;

export const PopulateApiParameters: HandlerType = props => {
    const { file } = props.parameter;
    props.apiParameter = {
        file,
    };
};

export const UploadItemTracking: HandlerType = async props => {
    try {
        props.apiResult = await uploadItemTrackingApi(props.apiParameter);
    } catch (error) {
            props.apiResult = error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, UploadItemTracking, ExecuteOnSuccess];

const uploadItemTrackingHandler = createHandlerChainRunner(chain, "uploadItemTrackingHandler");
export default uploadItemTrackingHandler;
